import axios from 'axios'

export default {
  list(params) {
    return axios.get('/spaces', { params }).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  get(id) {
    return axios.get('/spaces/' + id).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  save(data) {
    return axios.post('/spaces', data).then(response => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  delete(id) {
    return axios.post('/spaces/' + id + '/delete').then(response => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
}
